module.exports = __webpack_public_path__ + "static/logo-mobile-433651be8d9af247e2fd9d3023d5e796.svg";